import { useQueryInfo } from 'client/shared/containers/query';
import { QueryInfos } from 'client/shared/graphql-queries';
import { AiAssistant } from 'core';

export function usePublisherAiAssistant(pubId: string, assistant: AiAssistant) {
  const pubAssistant = useQueryInfo(QueryInfos.adminPublishingEntityAiAssistant, {
    variables: {
      publishingEntityId: pubId,
      assistant: {
        type: assistant.type,
        id: assistant.id,
      },
    },
    skip: assistant.type !== 'PubAssistant',
  });
  const result = pubAssistant.data?.openPublishingEntityById?.aiAssistant ?? null;
  return {
    loading: pubAssistant.loading,
    assistant: result,
  };
}
